import { z } from "zod";
import { ApplicantTypeEnum } from "types/Card";

// Schema for validating the application state used by ContactInformation
const ContactApplicationDataSchema = z.object({
    applicantType: ApplicantTypeEnum,
    firstName: z.string().optional(), // May not be prefilled from offerData (generic flow)
    lastName: z.string().optional(), // May not be prefilled from offerData (generic flow)
    month: z.string(),
    day: z.string(),
    year: z.string(),
    state: z.string(),
    zipCode: z.string().optional(),
    gender: z.enum(["male", "female"]).optional(),
    address: z.string().optional(), // May not be prefilled from offerData
    city: z.string().optional(), // May not be prefilled from offerData
});

export const ContactInformationStateSchema = z.object({
    application: ContactApplicationDataSchema.nullish(),
});
